export const CATEGORIES_DATA = [
  {
    id: "c1",
    title: "Cars",
    subCategories: [
      { id: "car_maruti", name: "Maruti Suzuki" },
      { id: "car_hyundai", name: "Hyundai" },
      { id: "car_tata", name: "Tata" },
      { id: "car_mahindra", name: "Mahindra" },
      { id: "car_honda", name: "Honda" },
      { id: "car_toyota", name: "Toyota" },
      { id: "car_bmw", name: "BMW" },
      { id: "car_all", name: "Others" },
    ],
  },

  {
    id: "c2",
    title: "Bikes",
    subCategories: [
      { id: "c2s1", name: "Motorcycles" },
      { id: "c2s2", name: "Scooters" },
      { id: "c2s3", name: "Spare Parts" },
      { id: "c2s4", name: "Bicycles" },
      { id: "c2s5", name: "Others" },
    ],
  },

  {
    id: "c4",
    title: "Electronics & Appliances",
    subCategories: [
      { id: "c4s1", name: "TVs & Audio" },
      { id: "c4s2", name: "Kitchen Appliances" },
      { id: "c4s3", name: "Computers & Laptops" },
      { id: "c4s4", name: "Cameras" },
      { id: "c4s5", name: "Games & Entertainment" },
      { id: "c4s6", name: "Fridges" },
      { id: "c4s7", name: "Accessories" },
      { id: "c4s8", name: "Wearables" },
      { id: "c4s9", name: "Printers & Monitors" },
      { id: "c4s10", name: "ACs" },
      { id: "c4s11", name: "Washing Machines" },
      { id: "c4s12", name: "Others" },
    ],
  },

  {
    id: "c5",
    title: "Mobiles",
    subCategories: [
      { id: "c5s1", name: "Mobile Phones" },
      { id: "c5s2", name: "Accessories" },
      { id: "c5s3", name: "Tablets" },
      { id: "c5s4", name: "Others" },
    ],
  },

  {
    id: "c7",
    title: "Furniture",
    subCategories: [
      { id: "c7s1", name: "Sofa & Dining" },
      { id: "c7s2", name: "Beds & Wardrobes" },
      { id: "c7s3", name: "Home Decor & Garden" },
      { id: "c7s4", name: "Kids Furniture" },
      { id: "c7s5", name: "Other Household Items" },
      { id: "c7s6", name: "Others" },
    ],
  },

  {
    id: "c3",
    title: "Properties",
    subCategories: [
      { id: "c3s1", name: "Houses & Apartments" },
      { id: "c3s4", name: "Shops & Offices" },
      { id: "c3s3", name: "Lands & Plots" },
      { id: "c3s6", name: "PG & Guest Houses" },
      { id: "c3s7", name: "Others" },
    ],
  },

  {
    id: "c8",
    title: "Books, Sports & Hobbies",
    subCategories: [
      { id: "c8s1", name: "Books" },
      { id: "c8s2", name: "Gym & Fitness" },
      { id: "c8s3", name: "Musical Instruments" },
      { id: "c8s4", name: "Sports Equipment" },
      { id: "c8s5", name: "Other Hobbies" },
      { id: "c8s6", name: "Others" },
    ],
  },

  {
    id: "c9",
    title: "Fashion",
    subCategories: [
      { id: "c9s1", name: "Women's Wear" },
      { id: "c9s2", name: "Men's Wear" },
      { id: "c9s3", name: "Jewelry" },
      { id: "c9s4", name: "Kids Fashion" },
      { id: "c9s5", name: "Others" },
    ],
  },

  {
    id: "c10",
    title: "Services",
    subCategories: [
      { id: "c10s1", name: "Education & Classes" },
      { id: "c10s2", name: "Tours & Travel" },
      { id: "c10s3", name: "Electronics Repair & Services" },
      { id: "c10s4", name: "Health & Beauty" },
      { id: "c10s5", name: "Home Renovation & Repair" },
      { id: "c10s6", name: "Cleaning & Pest Control" },
      { id: "c10s7", name: "Legal & Documentation Services" },
      { id: "c10s8", name: "Packers & Movers" },
      { id: "c10s9", name: "Other Services" },
      { id: "c10s10", name: "Others" },
    ],
  },

  {
    id: "c11",
    title: "Everything Else",
    subCategories: [],
  },
];